const locales = {
  en: {
    isoCode: 'en',
    label: 'English',
    languageSwitcherEnabled: true,
    automaticTranslationSupported: true,
    url: '/how-it-works',
    baseUrl: 'https://www.spotahome.com/'
  },
  es: {
    isoCode: 'es',
    label: 'Español',
    languageSwitcherEnabled: true,
    automaticTranslationSupported: true,
    url: '/es/como-funciona',
    baseUrl: 'https://www.spotahome.com/es/'
  },
  it: {
    isoCode: 'it',
    label: 'Italiano',
    languageSwitcherEnabled: true,
    automaticTranslationSupported: true,
    url: '/it/come-funziona',
    baseUrl: 'https://www.spotahome.com/it/'
  },
  fr: {
    isoCode: 'fr',
    label: 'Français',
    languageSwitcherEnabled: true,
    automaticTranslationSupported: true,
    url: '/fr/comment-fonctionne',
    baseUrl: 'https://www.spotahome.com/fr/'
  },
  de: {
    isoCode: 'de',
    label: 'Deutsch',
    languageSwitcherEnabled: true,
    automaticTranslationSupported: true,
    url: '/de/wie-es-funktioniert',
    baseUrl: 'https://www.spotahome.com/de/'
  },
  pt: {
    isoCode: 'pt',
    label: 'Português',
    languageSwitcherEnabled: true,
    automaticTranslationSupported: true,
    url: '/pt/como-funciona',
    baseUrl: 'https://www.spotahome.com/pt/'
  },
  tr: {
    isoCode: 'tr',
    label: 'Türkçe',
    languageSwitcherEnabled: true,
    automaticTranslationSupported: true,
    url: '/tr/nasil-calisiyor',
    baseUrl: 'https://www.spotahome.com/tr/'
  }
};

module.exports = locales;
